import { SharesMembersType } from "../../types";

export const configTabs = () => [
  { text: "全部", type: SharesMembersType.ALL },
  { text: "联系人", type: SharesMembersType.CONTACT },
  { text: "部门", type: SharesMembersType.DEPARTMENT },
  { text: "群", type: SharesMembersType.GROUP }
];
